var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadPhoto(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 34,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#upload-photo_svg__filter0_dd_6579_9148)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "upload-photo_svg__a",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.318 5.545C24.395 2.922 27.895 1 32.047 1c4.152 0 7.652 1.922 8.729 4.545h4.318a3 3 0 013 3V23a3 3 0 01-3 3H19a3 3 0 01-3-3V8.545a3 3 0 013-3h4.318z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M23.318 5.545v3h2.012l.764-1.86-2.776-1.14zm17.458 0L38 6.685l.764 1.86h2.012v-3zm-14.682 1.14C26.533 5.615 28.573 4 32.047 4v-6c-4.829 0-9.79 2.23-11.504 6.406l5.55 2.279zM32.047 4C35.522 4 37.561 5.614 38 6.685l5.551-2.279C41.837.23 36.876-2 32.047-2v6zm8.729 4.545h4.318v-6h-4.318v6zm4.318 0h6a6 6 0 00-6-6v6zm0 0V23h6V8.545h-6zm0 14.455v6a6 6 0 006-6h-6zm0 0H19v6h26.094v-6zM19 23h-6a6 6 0 006 6v-6zm0 0V8.545h-6V23h6zm0-14.455v-6a6 6 0 00-6 6h6zm0 0h4.318v-6H19v6z",
    fill: "#FFFCFE",
    mask: "url(#upload-photo_svg__a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.917 13.02h3.86v1.86h-3.86v3.9h-1.88v-3.9h-3.84v-1.86h3.84V9.08h1.88v3.94z",
    fill: "#FFFCFE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "upload-photo_svg__filter0_dd_6579_9148",
    x: 12,
    y: 1,
    width: 40.094,
    height: 33,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6579_9148"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_6579_9148",
    result: "effect2_dropShadow_6579_9148"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_6579_9148",
    result: "shape"
  })))));
}
export default SvgUploadPhoto;